import currency from 'currency.js'

const CurrencyPlugin = {
  install(Vue: any) {
    // eslint-disable-next-line no-param-reassign,no-multi-assign
    Vue.$currency = Vue.prototype.$currency = currency

    // eslint-disable-next-line no-param-reassign,no-multi-assign
    Vue.$currencyFormat = Vue.prototype.$currencyFormat = (value: any, precision = 2) => currency(value, { precision }).format()
  },
}

export default CurrencyPlugin
